import React, { useContext, useEffect, useState } from 'react'
import { EventMetaContext, MedPlanContext } from '../../SingleEvent'
import { FormControlLabel, Grid } from '@mui/material'
import S3DocumentUploadDisplay from '../../../../../components/images/S3DocumentUploadDisplay'
import EmergencyVehicleAccess from './EmergencyVehicleAccess'
import HospitalTransport from './HospitalTransport'
import IPCConsiderations from './IPCConsiderations'
import PatientReportForms from './PatientReportForms'
import EscalationOfCare from './EscalationOfCare'
import SpecialNotes from './SpecialNotes'
import NearestED from './NearestED'
import NearestTraumaUnit from './NearestTraumaUnit'
import NearestMTC from './NearestMTC'
import NearestPPCI from './NearestPPCI'
import NearestStroke from './NearestStroke'
import NearestMIU from './NearestMIU'
import API from '../../../../../services/API'
import PublicHealth from './PublicHealth'
import MajorIncidentPlan from './MajorIncidentPlan'
import OverwhelmPlan from './OverwhelmPlan'
import OPEL from './OPEL'
import Comms from './Comms'
import MajorTraumaNetwork from './MajorTraumaNetwork'
import { TenantSettingsContext } from '../../../../../App'
import Safeguarding from './Safeguarding'
import NearestPaediatrics from './NearestPaediatrics'
import NearestPaedsMTC from './NearestPaedsMTC'
import MartynsLaw from './MartynsLaw'
import PlanSection from './PlanSection'

const FormPanel = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { handleSave } = useContext(EventMetaContext)

  const [somethingToUpload, setSomethingToUpload] = useState(false)

  const [destinationOptions, setDestinationOptions] = useState([])

  const getDestinations = () => {
    API.get('/eventplanning/hospitals').then(
      (res) => res.status === 200 && setDestinationOptions(res.data),
    )
  }

  useEffect(() => getDestinations(), [])
  useEffect(() => {
    if (somethingToUpload) {
      handleSave()
      setSomethingToUpload(false)
    }
  }, [somethingToUpload])

  return (
    <Grid container spacing={2}>
      <PlanSection
        title="Command, Communications & Clinical Governance"
        subtitle="How the clinical team will communicate, record care, and manage safeguarding or public health concerns."
      />
      <Comms />
      <PatientReportForms />
      <PublicHealth />
      <Safeguarding />
      <IPCConsiderations />
      <SpecialNotes />

      <PlanSection
        title="Access, Transport & Receiving Hospitals"
        subtitle="Routes, ambulance access, conveyance decisions, and nearest suitable receiving centres."
      />
      <EmergencyVehicleAccess />
      <HospitalTransport />
      <NearestED
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('Emergency Department'),
        )}
        loadOptions={getDestinations}
      />
      <NearestTraumaUnit
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('Trauma Unit'),
        )}
        loadOptions={getDestinations}
      />
      <NearestMTC
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('Major Trauma Centre'),
        )}
        loadOptions={getDestinations}
      />
      <NearestPPCI
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('PPCI'),
        )}
        loadOptions={getDestinations}
      />
      <NearestStroke
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('Stroke'),
        )}
        loadOptions={getDestinations}
      />
      <NearestMIU
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('Minor Injury Unit'),
        )}
        loadOptions={getDestinations}
      />
      <NearestPaediatrics
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('Paediatrics'),
        )}
        loadOptions={getDestinations}
      />
      <NearestPaedsMTC
        destinationOptions={destinationOptions.filter((x) =>
          x.type.includes('Paediatric MTC'),
        )}
        loadOptions={getDestinations}
      />
      <MajorTraumaNetwork />

      <PlanSection
        title="Public Protection & Martyn's Law"
        subtitle="Preparedness for terrorist attacks and other public protection procedures for large public events."
      />
      <MartynsLaw />

      <PlanSection
        title="Escalation, Overwhelm & Major Incidents"
        subtitle="Clinical escalation routes, operational pressure levels, and actions when demand exceeds planned capacity."
      />
      <EscalationOfCare />
      <MajorIncidentPlan />
      <OverwhelmPlan />
      <OPEL />
    </Grid>
  )
}

export default FormPanel
